import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ErrorImage from '../assets/forzerofor.png'

function NotFound() {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const userLoggedIn = localStorage.getItem('isAuthenticated');
        if (userLoggedIn === 'true') {
            setIsAuthenticated(true);
        }
    }, []);

    const handleRedirect = () => {
        if (isAuthenticated) {
            navigate('/');
        } else {
            navigate('/home');
        }
    };

    return (
        <div className='error_outer'>
            <img src={ErrorImage}></img>
            <h1>404 Not Found</h1>
            <p>The page you're looking for doesn't exist.</p>
            <p>
                Back to{" "}
                <span className='not_found_back_btn' onClick={handleRedirect}>
                    {isAuthenticated ? 'Home Page' : 'Login Page'}
                </span>
            </p>
        </div>
    );
}

export default NotFound;
